import React from 'react'
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

import './NoOrders.sass'

const NoOrders: React.FC = () => {
    const {t} = useTranslation();
    return (
        <div className="no-orders">
            <h2>{t('basket.noOrders')}</h2>
            <NavLink to="/">
                {t('compare.goToMainPage')}
            </NavLink>
        </div>
    )
}

export default NoOrders;